/* ============
 * The initial state of the profile module.
 * ============
 */
export default {
  loading: false,
  user: {},
  status: ''
};
